import './index.scss';
import React from 'react';
import SVG from 'react-inlinesvg';
import Icons from "../../icons";
import {ResultHeaderFavorites} from "./Favorites";
import {ResultHeaderOverview} from "./Overview";


export const ResultHeader = (
    {
        selectMenu,
        setSelectMenu,
        collapsed,
        setCollapsed,
    }
) => {
    return (
        <div className="results-header d-flex flex-row flex-wrap align-items-center">
            {collapsed && (
                <button
                    className="d-flex flex-row align-items-center flex-nowrap mb-1"
                    onClick={() => setCollapsed(!collapsed)}
                >
                    <span>Angaben bearbeiten</span>
                    <SVG
                        src={Icons.edit_dark}
                        width="17"
                        height="17"
                    />
                </button>
            )}
            {!collapsed && (
                <button
                    className="d-flex flex-row align-items-center flex-nowrap mb-1"
                    onClick={
                        () => {
                            setCollapsed(!collapsed);
                        }
                    }
                >
                    <span>Angaben bearbeiten</span>
                    <SVG
                        src={Icons.close}
                        width="13"
                        height="13"
                    />
                </button>
            )}
            <ResultHeaderFavorites
                selectMenu={selectMenu}
                setSelectMenu={setSelectMenu}
            />
            <div className="flex-grow-1">&nbsp;</div>
            <ResultHeaderOverview
            />
        </div>
    );
}
